import { Component, OnInit } from '@angular/core';
import { AuthService } from '@rentigo/ngx-authorization';

@Component({
  template: ''
})
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.removeToken();
    this.authService.redirectToLogin();
  }
}
